<template>
  <div class="post-list">
    <div
      v-for="(post, index) in allPosts"
      :key="index"
      class="post_details">
        <router-link v-if="post.seo && post.seo.image" :to="{ 
          name: 'post',
          params: { 
            year: getDateObject(post.date).year,
            month: getDateObject(post.date).month,
            day: getDateObject(post.date).day,
            post: post.slug
          }
        }">
          <img :src="post.seo.image.url">
        </router-link>
        <h2>
          {{ post.seo && post.seo.title ?
            post.seo.title
            :
            post.title
          }} - 
          <router-link :to="{ 
            name: 'post',
            params: { 
              year: getDateObject(post.date).year,
              month: getDateObject(post.date).month,
              day: getDateObject(post.date).day,
              post: post.slug
            }
          }">
            details
          </router-link>
        </h2>
        <div v-if="post.seo && post.seo.description" v-html="parsedDescription(post.seo.description)" />
    </div>
  </div>    
</template>

<script>

import gql from 'graphql-tag'
import marked from 'marked'

export default {
  name: 'PostList',
  data() {
    return {
      allPosts: []
    }
  },
  props: [
    'size',
    'category'
  ],
  apollo: {
    allPosts: {
      query: gql`query AllPosts ($size: IntType, $category: ItemId ) {
        allPosts (
          first: $size,
          filter: {categories: {allIn: [$category]}},
          orderBy: [date_DESC]
        ) {
          title
          slug
          date
          seo {
            description
            title
            image { url }
            twitterCard
          }
        }
      }`,
      variables() {
        return {
          size: this.size,
          category: this.category
        }
      }
    }
  },
  methods: {
    parsedDescription(description) {
      return marked(description, {
        sanitize: false
      });
    },
    getDateObject: (dateString) => (([year, month, day]) => ({ day, month, year }))(dateString.split('T')[0].split('-'))
  }
}
</script>

<style scoped lang="less">

</style>
